import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const signinSearchSchema = z.object({
  redirect: z.string().optional(),
});

export type SigninSearch = z.infer<typeof signinSearchSchema>;

export const Route = createFileRoute('/auth/signin/')({
  head: () => ({
    meta: [{ title: 'Login' }],
  }),
  validateSearch: (search) => signinSearchSchema.parse(search),
});
